import React, { FC, useEffect, useState } from 'react'
import { CurrentUserType } from 'src/ducks/auth'
import LoadIcon from '../../components/LoadIcon'
import { LobbyEntry } from '../../components/LobbyEntry'
import PageWithBg from '../../components/PageWithBg'
import config from '../../config'
import Amplitude from '../../utils/amplitudeHelper'
import GameStand from '../../images/gamification/token-stand.png'
import MTEStand from '../../images/gamification/mte-stand.png'
import { StyledLobby } from './styled'

export const LobbyPage: FC<{ currentUser: CurrentUserType }> = ({ currentUser }) => {
  const [showLobbyModal, setShowLobbyModal] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    document.title = `${config.eventName} | Lobby`
  }, [])

  useEffect(() => {
    Amplitude.visit('Lobby')
  }, [currentUser.id])

  return (
    <>
      <StyledLobby>
        <PageWithBg bgImg={config.assets.lobby.landscape}>
          {config.lobbyEntries.map((entry) => {
            return <LobbyEntry key={entry.id} {...entry} currentUser={currentUser} />
          })}
          <div className="trailer" style={{background: isLoading ? '#fff' : 'transparent'}}>
            {isLoading && <LoadIcon />}
            <iframe
              width="100%"
              height="100%"
              title="Lobby Vimeo"
              src="https://player.vimeo.com/video/736016044?h=9f0ae94d4a&autoplay=1"
              allow="autoplay; fullscreen"
              allowFullScreen
              frameBorder="0"
              onLoad={() => {
                setIsLoading(false)
              }}
            />
          </div>
          <img id="game-stand" width="160px" src={GameStand} alt="game stand" />
          <img id="mte-stand" width="160px" src={MTEStand} alt="mte stand" />
          <div id="current-user">Logged in as {currentUser.email}</div>
        </PageWithBg>
      </StyledLobby>
    </>
  )
}
